import { render } from "./Navibar.vue?vue&type=template&id=5972ac34"
import script from "./Navibar.vue?vue&type=script&lang=js"
export * from "./Navibar.vue?vue&type=script&lang=js"

import "./Navibar.vue?vue&type=style&index=0&id=5972ac34&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__